import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './safari-fix.js'; // Import Safari-specific fixes

// Apply Safari detection and body class
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || 
  (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);

if (isSafari) {
  document.body.classList.add('safari-browser');
  console.log('Safari detected - applying compatibility mode');
  
  // Check if in iframe context
  try {
    if (window !== window.parent) {
      document.body.classList.add('safari-iframe');
      console.log('Safari in iframe context detected');
    }
  } catch (e) {
    // If error occurs when checking parent, we're in a cross-origin iframe
    document.body.classList.add('safari-iframe');
    console.log('Safari in cross-origin iframe detected');
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <a href="#main-content" className="skip-link">Skip to content</a>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();